<template>
  <div>
    <div class="title">Verteilgebiet planen</div>
    <p>
      Erreichen Sie Kunden in Ihrer Nähe! Tragen Sie in das Feld entweder eine Postleitzahl (z.B. 45127),
      eine Leitregion (z.B. 45) oder eine Leitzone (z.B. 4) ein.
    </p>
    <div class="autocomplete-container">
      <div class="input-group">
        <input
          ref="autocomplete"
          v-model="searchinput"
          type="text"
          class="form-control"
          name="location"
          placeholder="Postleitzahl, Leitregionen oder Leitzone eingeben"
          autocomplete="off"
        />
        <div class="input-group-append">
          <span class="input-group-text"><i class="fa fa-map-marker"></i></span>
        </div>
      </div>
    </div>
    <div class="autocomplete-messages" v-if="messages.length > 0">
      <div v-for="(message, index) in messages" :key="index">{{ message }}</div>
    </div>
  </div>
</template>

<script>
import { apiService } from "@/services/ApiService";
import autocomplete from "autocompleter";

export default {
  name: "RegionsSearch",

  props: {
    regions: Array,
  },

  data() {
    return {
      searchinput: "",
      maxAddresses: "",
      messages: [],
    };
  },

  mounted() {
    // https://github.com/kraaden/autocomplete
    autocomplete({
      input: this.$refs.autocomplete,
      debounceWaitMs: 500,
      minLength: 1,
      emptyMsg: "",
      fetch: this.search,
      onSelect: this.addRegion,
      render: this.render,
      preventSubmit: true,
    });
  },

  methods: {
    search(search, update) {
      this.messages = [];
      apiService
        .search(search, this.regions)
        .then((response) => {
          // console.debug("RegionsSearch API response", response);
          if (response.success) {
            update([response.result]);
          } else {
            update([]);
            this.messages = response.messages;
          }
        })
        .catch((error) => {
          console.error("Error", error);
        });
    },
    render(item) {
      const itemElement = document.createElement("div");
      itemElement.textContent = 'Verteilgebiet ' + item.label + ' mit ' + new Intl.NumberFormat().format(item.potenzial) + ' Adressen hinzufügen';
      return itemElement;
    },
    addRegion(item) {
      this.$emit("add-region", item);
      this.$refs.autocomplete.value = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 800;
  font-size: 18px;
  margin-bottom: 5px;
}

.autocomplete-messages {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-top: 1rem;
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.autocomplete-container {
  > .input-group > input {
    padding: 20px 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 0;
  }
}
</style>

<style lang="scss">
$border-color: #dee2e6;
$popover-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2);
$light: #f5f5f5;

.autocomplete {
  background: white;
  z-index: 2000;
  overflow: auto;
  box-sizing: border-box;
  border: 1px solid $border-color;
  box-shadow: $popover-box-shadow;

  & > div {
    padding: 0.5rem 1rem;
    text-align: left;
  }

  .group {
    background: #eee;
  }

  & > div:hover:not(.group),
  & > div.selected {
    background: $light;
    font-weight: bold;
    cursor: pointer;
  }
  & > div:hover:not(.group) {
    text-decoration: underline;
  }
}
</style>
